export const createDefaultMountingTarget = (targetSelector: string): HTMLElement => {
    const existingTarget = document.querySelector(targetSelector);

    if (existingTarget) {
        return existingTarget as HTMLElement;
    }

    const target = document.createElement('div');
    target.id = targetSelector.replace('#', '');
    document.body.appendChild(target);

    return target;
};
